const doc = [({"da":({"js":({"contact_merge_requests":({"confirm_merge_request":({"the_users_were_merged":"Brugerne blev sammenlagt."})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;